import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrFilterIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M12.5 8.5C12.5 8.63261 12.4473 8.75979 12.3536 8.85355C12.2598 8.94732 12.1326 9 12 9H4C3.86739 9 3.74021 8.94732 3.64645 8.85355C3.55268 8.75979 3.5 8.63261 3.5 8.5C3.5 8.36739 3.55268 8.24021 3.64645 8.14645C3.74021 8.05268 3.86739 8 4 8H12C12.1326 8 12.2598 8.05268 12.3536 8.14645C12.4473 8.24021 12.5 8.36739 12.5 8.5ZM14.5 5H1.5C1.36739 5 1.24021 5.05268 1.14645 5.14645C1.05268 5.24021 1 5.36739 1 5.5C1 5.63261 1.05268 5.75979 1.14645 5.85355C1.24021 5.94732 1.36739 6 1.5 6H14.5C14.6326 6 14.7598 5.94732 14.8536 5.85355C14.9473 5.75979 15 5.63261 15 5.5C15 5.36739 14.9473 5.24021 14.8536 5.14645C14.7598 5.05268 14.6326 5 14.5 5ZM9.5 11H6.5C6.36739 11 6.24021 11.0527 6.14645 11.1464C6.05268 11.2402 6 11.3674 6 11.5C6 11.6326 6.05268 11.7598 6.14645 11.8536C6.24021 11.9473 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 11.9473 9.85355 11.8536C9.94732 11.7598 10 11.6326 10 11.5C10 11.3674 9.94732 11.2402 9.85355 11.1464C9.75979 11.0527 9.63261 11 9.5 11Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrFilterIconComponent;
